const interface_ = {
  data: () => ({
    wtInterface: {}
  }),
  methods: {
    dialogClasses () {
      const fullScreenDialog = document.querySelector('.full-screen-dialog:not(.v-dialog__content)')
      const defaultDialog = document.querySelector('.default-dialog:not(.v-dialog__content)')
      const confirmDialog = document.querySelector('.v-dialog.vuedl-layout')
      if (fullScreenDialog !== null && !fullScreenDialog.parentElement.classList.contains('full-screen-dialog')) fullScreenDialog.parentElement.classList.add('fullScreenDialog')
      if (defaultDialog !== null && !defaultDialog.parentElement.classList.contains('default-dialog')) defaultDialog.parentElement.classList.add('defaultDialog')
      if (confirmDialog !== null && !confirmDialog.parentElement.classList.contains('confirm-dialog')) confirmDialog.parentElement.classList.add('confirmDialog')
    }
  },
  updated () {
    this.$nextTick(() => {
      const vm = this
      clearTimeout(this.wtInterface.timeout)
      this.wtInterface.timeout = setTimeout(function () {
        vm.dialogClasses()
      }, 500)
    })
  }
}

export default interface_
